






import Vue from 'vue';

import OrganizationUser from '@/views/authenticated/OrganizationUser.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    OrganizationUser,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    userId: Number
  }
});
